import styled, { createGlobalStyle, css } from 'styled-components';
import { TRANCHE_STATUS } from './TrancheStatus.dataManipulation';

// Pending text reads as ink at secondary opacity, like the description,
// because messaging.unknown is too faint to read against the panel.
const pendingOpacity = css`
  ${({ $status, theme }) =>
    $status === TRANCHE_STATUS.PENDING &&
    `opacity: ${theme.opacity.secondary};`}
`;

export const BadgeButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`;
BadgeButton.displayName = 'BadgeButton';

export const BadgeContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.sizing.small};
`;
BadgeContent.displayName = 'BadgeContent';

export const DotsRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.sizing.xtiny};
`;
DotsRow.displayName = 'DotsRow';

export const Dot = styled.span`
  display: inline-block;
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: ${({ theme }) => theme.borderRadius.primary};
  background: ${({ $filled }) => ($filled ? 'currentColor' : 'transparent')};
  border: 1px solid currentColor;
`;
Dot.displayName = 'Dot';

export const IconWrapper = styled.span`
  display: inline-flex;
  color: ${({ $status, theme }) => {
    if ($status === TRANCHE_STATUS.AVAILABLE)
      return theme.colours.messaging.success.strong;
    if ($status === TRANCHE_STATUS.ERROR)
      return theme.colours.messaging.error.strong;
    return theme.colours.layering[1].main;
  }};
`;
IconWrapper.displayName = 'IconWrapper';

export const FlyoutCornerStyles = createGlobalStyle`
  [data-testid='tranche-status-flyout'] > div {
    border-radius: ${({ theme }) => theme.borderRadius.secondary};
  }
`;

export const Panel = styled.div`
  width: 300px;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.borderRadius.secondary};
  border: 1px solid ${({ theme }) => theme.colours.layering[1].main};
`;
Panel.displayName = 'Panel';

export const TrancheRow = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: ${({ theme }) => theme.sizing.regular};
  align-items: flex-start;
  padding: ${({ theme }) => theme.sizing.regular};
  &:not(:last-child) {
    border-bottom: ${({ theme }) =>
      `${theme.sizing.xxtiny} solid ${theme.colours.layering[1].main}`};
  }
`;
TrancheRow.displayName = 'TrancheRow';

export const TrancheInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.tiny};
`;
TrancheInfo.displayName = 'TrancheInfo';

export const TrancheTitle = styled.div`
  ${({ theme }) => theme.typography.headingSmall};
  color: ${({ theme }) => theme.colours.ink.primary.main};
`;
TrancheTitle.displayName = 'TrancheTitle';

export const TrancheDescription = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colours.ink.primary.main};
  opacity: ${({ theme }) => theme.opacity.secondary};
`;
TrancheDescription.displayName = 'TrancheDescription';

export const StatusText = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ $status, theme }) => {
    if ($status === TRANCHE_STATUS.AVAILABLE)
      return theme.colours.messaging.success.strong;
    if ($status === TRANCHE_STATUS.ERROR)
      return theme.colours.messaging.error.strong;
    return theme.colours.ink.primary.main;
  }};
  ${pendingOpacity}
  white-space: nowrap;
`;
StatusText.displayName = 'StatusText';
